export default {
    "Decentralization": "分散化",
    "Coin-based": "コインベース",
    "Perpetual Options": "永久オプション",
    "Future Derivatives Infrastructure": "将来のデリバティブ インフラストラクチャ",
    "Start Trading": "取引を開始",
    "Trading": "取引",
    "Follow":"コピートレード",
    "Fund Pool": "ファンドプール",
    "Recommendation Reward": "推薦報酬",
    "Language": "言語",
    "Never Liquidate": "決して清算しない",
    "Eliminate Liquidation Risk": "清算リスクを排除する",
    "Risk Management Easier": "リスク管理が簡単になります",
    "High Leverage": "高レバレッジ",
    "Multiple Leverage": "複数のレバレッジ",
    "High Profit Potential": "高い利益の可能性",
    "Zero Slippage": "ゼロスリッページ",
    "Execution Price Meets Expected Results": "実行価格は期待通りの結果を達成",
    "Eliminate Impermanent Loss": "一時的な損失を排除する",
    "Commission Rate 15%": "手数料率 50%",
    "Generous recommendation rewards, recognize your contribution": "寛大な推薦報酬,あなたの貢献を認めます",
    "Generous recommendation rewards, recognize your contribution2": "寛大な推薦報酬<br/>あなたの貢献を認めます",
    "Invite a friend": "友達を招待する",
    "Invite a friend to Fufuture via a referral link": "紹介リンク経由で友達をFufutureに招待する",
    "Friend completes first order": "友人が最初の注文を完了する",
    "Friend accepts invitation and completes first order": "友人が招待を受け入れ,最初の注文を完了する",
    "Get your commission": "コミッションを獲得する",
    "Get your commission immediately and claim it anytime": "すぐにコミッションを獲得し,いつでも請求できます",
    "Create my link": "リンクを作成",
    "Deep liquidity supported by dual pools": "デュアルプールによってサポートされる深い流動性",
    "Public pool": "公共プール",
    "Available liquidity": "利用可能な流動性",
    "Private pool": "プライベートプール",
    "Add LP": "LP を追加",
    "FAQ": "よくある質問",
    "Future Derivatives Infrastructure2": "将来のデリバティブ インフラストラクチャ",
    "Dual liquidity pool": "デュアル流動性プール",
    "Open liquidity pool": "流動性プールを開く",
    "More stable liquidity": "より安定した流動性",
    "Reasonable pricing": "リーズナブルな価格設定",
    "Price feed from third-party oracle": "サードパーティのオラクルからの価格フィード",
    "Precise error control": "正確なエラー制御",
    "BTC BTC 24-hour trading volume summary": "BTC 24時間取引量サマリー",
    "BTC holdings summary": "BTC 保有状況の概要",
    "ETH 24-hour trading volume summary": "ETH 24時間取引量サマリー",
    "ETH holdings summary": "ETH 保有状況の概要",
    "q1":"アカウントのセキュリティを強化するにはどうすればいいですか?",
    "a1":"ウォレットを介して取引ウェブサイトにアクセスし、個人の秘密鍵を保護し、フィッシングリンクをクリックしたり、不明なQRコードをスキャンしたりしないでください。",
    "q2":"入金するにはどうすればいいですか?",
    "a2":"Futureで対象トークンが配置されているパブリックチェーンを選択し、入金操作の対象トークンを選択します。",
    "q3":"Future の取引手数料はいくらですか?",
    "a3":"永久オプションはポジションを開くときにのみ 1‰ を請求します。"

}
